import React from 'react';
import PropTypes from 'prop-types';

import { DateStyles } from '../../constants/CentricConstants';
import { FormattedDate } from 'react-intl';
import { Link } from 'react-router';

import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';

const isSameDay = (startDate, endDate) => {

    const start = new Date(startDate);
    const end = new Date(endDate);

    return (
        start.getFullYear() === end.getFullYear() &&
        start.getMonth() === end.getMonth() &&
        start.getDate() === end.getDate()
    )
};

const EventDialog = ({title, event, onClose, editLink}) => {

    if (!event) return null;

    const sameday = isSameDay(event.timeStart, event.timeEnd );

    const actions = [<FlatButton label="close"  onTouchTap={onClose} />];
    if (!!editLink) {
        actions.push(<Link to={editLink}><FlatButton label="edit" primary={true} /></Link>);
    }

    return (

        <Dialog
            open={true}
            title={title || event.name}
            modal={false}
            onRequestClose={onClose}
            actions={actions}
        >
            {sameday && (
                <p><FormattedDate value={new Date(event.timeStart)} {...DateStyles.fullDay} /></p>
            )}

            {sameday && (
                <p>{event.timeStart.format('h:mm:ss')} - {event.timeEnd.slice(11, 16)}</p>
            )}
            {!!event.venueId && (
                <p>Venue: <Link to={`/dashboard/venue/${event.venueId}`}>{event.venue}</Link>
                    {!!event.locationId && (
                        <span>, <Link to={`/dashboard/location/${event.locationId}`}> {event.location}</Link></span>
                    )}
                </p>
            )}
            <p>{event.attendeeCount} / {event.capacity} attending</p>
            {!!event.trainers && event.trainers.length > 0 && (
                <p>Trainers: {event.trainers.map((tr) => (`${tr.firstName} ${tr.lastName}`)).join(', ')}</p>
            )}
            <p><Link to={`/dashboard/event/${event.id}`}>More details</Link></p>
        </Dialog>
    );
};

EventDialog.propTypes = {
    title:      PropTypes.string,
    event:      PropTypes.object,
    onClose:    PropTypes.func,
    editLink:   PropTypes.string
};

export default EventDialog;
